import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Admin from './pages/Admin';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import ProtectedRoute from './components/ProtectedRoute';
import ClerkProviderWithRouter from './components/ClerkProviderWithRouter'; // ÚJ
import { ThemeProvider } from './contexts/ThemeContext';

import MaganoraPage from './pages/MaganoraPage';
import AgykontrollPage from './pages/AgykontrollPage';
import TanulasTreningPage from './pages/TanulasTreningPage';
import CsillagPage from './pages/CsillagPage';
import AuthPages from './pages/AuthPages';
import LetolthetoTartalmak from './pages/LetolthetoTartalmak';
import Ujdonsagok from './pages/Ujdonsagok';
import MI from './pages/MI';
import Profile from './pages/Profile';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ScrollToTopButton from "./components/ScrollToTopButton";

import RouteTransitionWrapper from "./components/RouteTransitionWrapper";
import RouteTracker from "./components/RouteTracker";
import AfterLogin from "./pages/AfterLogin";
import "./styles/brand.css";
import "./styles/responsive.css";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const App: React.FC = () => {
  // Fejlesztési időszakra: barátságos üzenet a hiányzó kulcsról (korábban az index.tsx-ben volt)
  if (!PUBLISHABLE_KEY) {
    return (
      <div style={{ padding: 20 }}>
        <h2>Clerk publishable key hiányzik</h2>
        <p>
          Add meg a <code>REACT_APP_CLERK_PUBLISHABLE_KEY</code> értékét a <code>.env</code> fájlban
          a projekt gyökérkönyvtárában, majd indítsd újra a dev szervert.
        </p>
        <p>
          Kulcs beszerezhető: <a href="https://dashboard.clerk.com/">Clerk dashboard</a>.
        </p>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <ScrollToTopButton />
      <Router>
        {/* A ClerkProvider a Router BELSEJÉBEN van (az index.tsx-ből már ki van véve) */}
        <ClerkProviderWithRouter publishableKey={PUBLISHABLE_KEY}>
          <RouteTracker />
          <RouteTransitionWrapper>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/maganora" element={<MaganoraPage />} />
              <Route path="/gyermekagykontroll" element={<AgykontrollPage />} />
              <Route path="/tanulasitrening" element={<TanulasTreningPage />} />
              <Route path="/chillag" element={<CsillagPage />} />
              <Route path="/authpages" element={<AuthPages />} />
              {/* Minden sikeres belépés / regisztráció után ide érkezik a Clerk, innen megyünk tovább */}
              <Route path="/after-login" element={<AfterLogin />} />
              <Route path="/letolthetotartalmak" element={<LetolthetoTartalmak />} />
              <Route path="/ujdonsagok" element={<Ujdonsagok />} />
              <Route path="/ai" element={<MI />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />

              {/* SECURE PATH */}
              <Route element={<ProtectedRoute />}>
                {/* /* kell: a Clerk fülei (/profile/security, /profile/subscription) ide érkeznek */}
                <Route path="/profile/*" element={<Profile />} />
              </Route>

              {/* ADMIN SECURE PATH */}
              <Route element={<AdminProtectedRoute />}>
                <Route path="/admin" element={<Admin />} />
              </Route>
            </Routes>
          </RouteTransitionWrapper>
        </ClerkProviderWithRouter>
      </Router>
    </ThemeProvider>
  );
};

export default App;